module.exports = __webpack_public_path__ + "img/li-siqi.c46a706d.jpeg";